import GeneralModal from "../GeneralModal";


function JSPaintApp(props: any) {
    // pixel art image of weed leaf
    const imageUrl = "https://i.imgur.com/0Z1Z1Z0.png"

    let frameUrl = "https://jspaint.app"


    if (props.imageURL) {
        frameUrl += "#load:" + props.imageURL
    }

    return (
        <GeneralModal id='mspaint'>
            <iframe src={frameUrl} width="100%" height="100%"></iframe>
        </GeneralModal>
    );
}

export default JSPaintApp;
